import React, { Component } from "react";
import { observer } from "mobx-react";
import Tab from "../tap";
import Title from "../GoBackShop";
import MailItem from "../MailItem";
import "./index.css";
import { ListView } from "antd-mobile";
import { Allqustion } from "../../static/js/http";
import Modal from "../Modal";
@observer
class Mymailbox extends Component {
  constructor() {
    super();
    const dataSource = new ListView.DataSource({
      rowHasChanged: (row1, row2) => row1 !== row2, // rowHasChanged(prevRowData, nextRowData); 用其进行数据变更的比较
    });
    this.state = {
      dataSource,
      datas: [],
      page: 0,
      size: 20,
      hasMore: true,
      refreshing: true,
      isLoading: true,
      dataArr: [],
      showId: "0",
      totalElements: 0,
      totalPages: 0,
      selectData: {},
      showModal: false,
      input: "",
      groupData: {},
      newLoading: false,
    };
  }
  componentDidMount() {
    this.getList();
  }
  getList() {
    this.setState({
      refreshing: false,
      isLoading: true,
      hasMore: false,
      newLoading: true,
    });
    let params = {
      page: this.state.page,
      size: this.state.size,
      type: 4,
    };
    Allqustion(params)
      .then((res) => {
        if (res.msg === "success") {
          let newDat =
            res.data &&
            res.data.pageData &&
            res.data.pageData.filter((item) => item.storeQuestionEntity.isShow);
          let dataArr = this.state.dataArr.concat(newDat);
          this.setState({
            dataSource: this.state.dataSource.cloneWithRows(dataArr), // 数据源中的数据本身是不可修改的,要更新datasource中的数据，请（每次都重新）调用cloneWithRows方法
            refreshing: false,
            isLoading: false,
            dataArr: dataArr, // 保存新数据进state
            totalElements: res.data.totalElements,
            totalPages: res.data.totalPages,
            newLoading: false,
          });
        }
      })
      .catch((err) => {});
  }
  getData(ref = false) {
    //获取数据
    let para = {
      page: this.state.page,
      size: this.state.size,
      type: 4,
    };
    this.setState({
      refreshing: false,
      isLoading: true,
      hasMore: false,
    });
    Allqustion(para)
      .then((res) => {
        if (res.msg === "success") {
          let newDat =
            res.data &&
            res.data.pageData &&
            res.data.pageData.filter((item) => item.storeQuestionEntity.isShow);
          let dataArr = this.state.dataArr.concat(newDat);
          this.setState({
            dataSource: this.state.dataSource.cloneWithRows(dataArr), // 数据源中的数据本身是不可修改的,要更新datasource中的数据，请（每次都重新）调用cloneWithRows方法
            refreshing: false,
            isLoading: false,
            dataArr: dataArr, // 保存新数据进state
            totalElements: res.data.totalElements,
            totalPages: res.data.totalPages,
            page: this.state.page + 1,
          });
        }
      })
      .catch((err) => {});
  }
  onEndReached = (event) => {
    if (this.state.page + 1 <= this.state.totalPages) {
      if (this.state.totalElements - this.state.dataArr.length >= 1) {
        this.setState({
          refreshing: true,
          isLoading: true,
        });
        this.getData();
      } else {
        this.setState({
          refreshing: true,
          isLoading: false,
          hasMore: false,
        });
      }
    } else {
      this.setState({
        refreshing: true,
        isLoading: false,
        hasMore: false,
      });
    }
  };
  changeShowId(rowData) {
    this.setState({
      selectData: rowData,
      showModal: true,
      showId: rowData.storeQuestionEntity.id,
      groupData: rowData.storeGroupEntity,
    });
  }
  // 关闭弹窗
  close() {
    this.setState(
      {
        selectData: {},
        showModal: false,
        showId: "",
        groupData: {},
        dataArr: [],
        page: 0,
      },
      () => {
        this.getList();
      }
    );
  }
  render() {
    const row = (rowData, sectionID, rowID) => {
      // 这里rowData,就是上面方法cloneWithRows的数组遍历的单条数据了，直接用就行
      return (
        <MailItem
          bg="un"
          rowData={rowData}
          sectionID={sectionID}
          people={rowData && rowData.storeGroupEntity}
          rowID={rowID}
          key={rowID}
          changeShowId={(rowData) => this.changeShowId(rowData)}
        />
      );
    };
    const Loading = () => {
      return (
        <div className="loading">
          <span></span>
          <p>正在加载...</p>
        </div>
      );
    };
    return (
      <div className="my_mailbox">
        <Title />
        {this.state.newLoading ? (
          <Loading />
        ) : (
          <div className="mailbox_cnt">
            <div className="mailbox_cnt_top"></div>
            <div className="mailbox_cnt_cnt">
              <div className="mailbox_cnt_cnt_bg">
                <div className="mailbox_cnt_cnt_bg_title"></div>
                <div className="mailbox_cnt_cnt_bg_list">
                  {this.state.dataArr.length !== 0 ? (
                    <ListView
                      ref={(el) => (this.myemail = el)}
                      dataSource={this.state.dataSource}
                      initialListSize={20}
                      scrollEventThrottle={200}
                      renderRow={row}
                      renderFooter={() =>
                        this.state.isLoading ? (
                          <div className="footer">
                            {this.state.isHasMore
                              ? "加载中..."
                              : "暂无更多数据"}
                          </div>
                        ) : (
                          ""
                        )
                      }
                      onEndReachedThreshold={50}
                      onEndReached={this.onEndReached.bind(this)}
                      pageSize={1}
                      style={{
                        width: "100%",
                        height: "98%",
                        overflow: "auto",
                      }}
                    />
                  ) : (
                    <div className="mailbox_list_noquestion">
                      <span>你还没有提问过问题哦</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        <Tab />
        {this.state.showModal ? (
          <Modal
            showModal={this.state.showModal}
            showInput={true}
            showLike={false}
            showMore={true}
            groupData={this.state.selectData.storeGroupEntity}
            detailId={this.state.showId}
            close={() => {
              this.close();
            }}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default Mymailbox;
